<template>
    <section class="practice">
        <vue-snotify></vue-snotify>
        <div class="row">
            <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content col-md-9 col-sm-12">
                <div class="material-box bg-white">
                    <div class="col-md-12 top-title">
                        <h3>Edit User</h3>
                    </div>
                    <div class="col-md-12">
                        <div class="section-container section-with-top-border p-b-10 ">
                            <form class="form-horizontal fv-form fv-form-bootstrap" @submit.prevent="saveUser"
                                method="post" enctype="multipart/form-data">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="FirstName">First Name</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-user"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="FirstName" name="FirstName"
                                                    autocomplete="FirstName" placeholder="First Name"
                                                    v-model="userData.FirstName"
                                                    :state="$v.userData.FirstName.$dirty ? !$v.userData.FirstName.$error : null"
                                                    aria-describedby="input-1-live-feedback"
                                                    label="First Name"></b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <div class="form-group">
                                            <label for="LastName">Last Name:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-user"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="LastName" name="LastName"
                                                    autocomplete="LastName" placeholder="Last Name"
                                                    v-model="userData.LastName"
                                                    :state="$v.userData.LastName.$dirty ? !$v.userData.LastName.$error : null"
                                                    aria-describedby="input-1-live-feedback"
                                                    label="Last Name"></b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <div class="form-group">
                                            <label for="Prefix">Prefix:</label>
                                            <b-input-group prepend="@">
                                                <b-form-select id="Prefix" v-model="userData.Prefix"
                                                    :options="PrefixOptions" value-field="item"
                                                    :state="$v.userData.Prefix.$dirty ? !$v.userData.Prefix.$error : null"
                                                    text-field="item">
                                                </b-form-select>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <div class="form-group">
                                            <label for="Status">Status:</label>
                                            <b-input-group prepend="@">
                                                <b-form-select id="Status" v-model="userData.Status"
                                                    :options="StatusOptions" value-field="item"
                                                    :state="$v.userData.Status.$dirty ? !$v.userData.Status.$error : null"
                                                    text-field="item">
                                                </b-form-select>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                        </div>
                                        <!-- <div class="form-group m-b-10">
                                            <label class="control-label">User Name:</label>
                                            <div class="input-group ">
                                                <legend> Your email address will be used as your Username</legend>
                                            </div>
                                        </div> -->
                                        <div class="form-group">
                                            <label for="Password">Password:</label>
                                            <b-input-group class="mb-1">
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-key"></i>
                                                </b-input-group-prepend>
                                                <b-form-input :type="pField" id="Password" name="Password"
                                                    autocomplete="Password" v-model="userData.Password"
                                                    aria-describedby="input-1-live-feedback"
                                                    placeholder="Enter password For changing" required></b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                            <input type="checkbox" @click="showPass">Show the password
                                        </div>
                                        <div class="form-group">
                                            <label for="Email">Email:</label>
                                            <b-input-group prepend="@">
                                                <b-form-input type="email" id="Email" name="Email" autocomplete="Email"
                                                    placeholder="Email" v-model="userData.Email"
                                                    aria-describedby="input-1-live-feedback"
                                                    :state="$v.userData.Email.$dirty ? !$v.userData.Email.$error : null"
                                                    label="Email"></b-form-input>
                                                <b-form-invalid-feedback  id="input-1-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                            </b-input-group> 
                                            <span class="text-danger" v-if="emailErr != ''">{{ emailErr }}</span>
                                        </div>
                                        <div class="row m-4">
                                            <div class="col-md-6 from-group">
                                                <img :src="userData.url" alt="Old Image" class="img-fluid" />
                                                <!-- <img src="oldImagePrev" alt=""> -->
                                                <input type="file" ref="fileInput" @change="handleFileUpload" />
                                                <img v-if="imagePreviewUrl" :src="imagePreviewUrl" alt="Image Preview"
                                                    class="img-fluid" />
                                                <button v-if="imagePreviewUrl" @click="removeImage">Remove
                                                    Image</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="Address1">Address</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-globe"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" v-model="userData.Address1" id="Address1"
                                                    name="Address1" autocomplete="Address1"></b-form-input>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="Address1">
                                                This is a required field.
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="form-group">

                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-globe"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="Address2" name="Address2"
                                                    autocomplete="Address2" v-model="userData.Address2"></b-form-input>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="Address2">
                                                This is a required field.
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="form-group">
                                            <label for="City">City:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-globe"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="City" name="City" autocomplete="City"
                                                    v-model="userData.City"></b-form-input>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="City">
                                                This is a required field.
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="form-group">
                                            <label for="StateID">State:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-globe"></i>
                                                </b-input-group-prepend>
                                                <b-form-select id="StateID" v-model="userData.StateID"
                                                    :options="StateOptions" value-field="StateID" text-field="Name">
                                                </b-form-select>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="StateID">
                                                This is a required field.
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="form-group">
                                            <label for="Zip">Zip:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-globe"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="Zip" name="Zip" autocomplete="Zip"
                                                    v-model="userData.Zip"></b-form-input>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="Zip">
                                                This is a required field.
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="form-group">
                                            <label for="Phone1">Phone1:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-phone"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="Phone1" name="Phone1"
                                                    autocomplete="Phone1" v-model="userData.Phone1"></b-form-input>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="Phone1">
                                                This is a required field.
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div class="form-group">
                                            <label for="Phone2">Mobile:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-phone"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="Phone2" name="Phone2"
                                                    autocomplete="Phone2" v-model="userData.Phone2"></b-form-input>
                                            </b-input-group>
                                        </div>
                                        <!-- <div class="form-group">
                                            <label for="Fax">Fax:</label>
                                            <b-input-group>
                                                <b-input-group-prepend is-text>
                                                    <i class="fa fa-phone"></i>
                                                </b-input-group-prepend>
                                                <b-form-input type="text" id="Fax" name="Fax" autocomplete="Fax"
                                                    v-model="userData.Fax"></b-form-input>
                                            </b-input-group>
                                        </div> -->
                                        <div class="form-group"
                                            v-if="userData.Status == 'PCA' && (loginUser.UserID == 1 || loginUser.UserID == 2)">
                                            <label for="allow">allowed pages:</label>
                                            <multiselect id="allow" :multiple="true" v-model="allowedPages"
                                                :custom-label="pageLabel" :options="pages" @input="allowPageFn">
                                            </multiselect>
                                        </div>
                                        <div class="form-group"
                                            v-if="userData.Status == 'PCA' && (loginUser.UserID == 1 || loginUser.UserID == 2)">
                                            <label for="limited">Limited Admin:</label>
                                            <input type="checkbox" :checked="userData.Admin == 1" @click="limitedAdmin">
                                        </div>
                                        <div class="mt-3">
                                            <div class="row text-right">
                                                <router-link :to="{ name: 'view_dashboard_user' }"
                                                    class="btn btn-primary m-r-5"><i class="fa fa-arrow-left"></i>
                                                    Back </router-link>
                                                <button type="submit" class="btn btn-success ">Save</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Multiselect from 'vue-multiselect'

export default {
    name: "view_user",
    components: {
        practiceSidebar, Multiselect
    },
    mixins: [validationMixin],
    data() {
        return {
            isLoading: false,
            oldImagePrev: '',
            pField: "password",
            loginUser: {},
            emailErr: "",
            imagePreviewUrl: '',
            StateOptions: [],
            pages: [
                'SeminarPackingItems',
                'Members',
                'Seminars',
                'Webinar',
                'EmailMarketing',
                'Referrals',
                'Modules',
                'Documents',
                'Videos',
                'Webcontent'
            ],
            allowedPages: [],
            userData: {
                FirstName: "",
                LastName: "",
                Prefix: "",
                Status: "",
                Password: "",
                Email: "",
                Image: null,
                allowedPages: '',
                StateID: "",
                Fax: "",
                Phone2: "",
                Phone1: "",
                City: "",
                Address1: "",
                Address2: "",
                Admin: 0,
                email: "",
            },
            StatusOptions: [
                { item: 'PDC' },
                { item: 'PCA' },
                { item: 'DC' },
                { item: 'CA' },
            ],
            PrefixOptions: [
                { item: "Dr." },
                { item: "Mr." },
                { item: "Mrs." },
                { item: "Ms." },
            ]
        }
    },
    validations: {
        userData: {
            FirstName: {
                required,
            },
            Email: {
                required, email
            },
            LastName: {
                required,
            },
            Status: {
                required,
            },
            Prefix: {
                required
            },
            // Address1: {
            //     required,
            // },
            // StateID: {
            //     required,
            // },
            // Address2: {
            //     required,
            // },
            // City: {
            //     required,
            // },
            // Zip: {
            //     required,
            // },
            // Phone1: {
            //     required,
            // },
        }
    },
    methods: {
        getStates() {
            this.isLoading = true;
            userAPI.getStates(res => {
                this.StateOptions = res.data.data;
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        },
        limitedAdmin(event) {
            this.userData.Admin = event.target.checked ? 1 : 0;
        },
        allowPageFn() {
            this.userData.allowedPages = this.allowedPages.join(",");
        },
        pageLabel(allow) {
            return allow;
        },
        handleFileUpload(event) {
            const file = event.target.files[0];

            // Store the selected file
            this.userData.Image = file;

            // Read the file and generate a preview URL
            const reader = new FileReader();
            reader.onload = () => {
                this.imagePreviewUrl = reader.result;
            };
            reader.readAsDataURL(file);
        },
        showPass() {
            this.pField = this.pField == 'text' ? 'password' : 'text';
        },
        removeImage() {
            this.imagePreviewUrl = '';
            this.userData.Image = null;
            this.$refs.fileInput.value = '';
        },
        saveUser() {
            this.$v.userData.$touch()

            if (this.$v.userData.$anyError) {
                return;
            }

            userAPI.editUserFromDashboard({ ...this.userData, ...{ PracticeID: this.loginUser.PracticeID } },
                res => {
                    this.$showNotification({ message: res.data.message }, "success")
                    // this.$router.push({ name: 'view_dashboard_user' });
                    setTimeout(() => {
                        this.$router.push({ name: 'view_dashboard_user' });
                    }, 3000);
                }, err => {
                    if (err.response.data.errors.Email) {
                        this.$showNotification({ message: err.response.data.errors.Email[0] }, "error") 
                        this.emailErr = err.response.data.errors.Email[0] 
                    }
                    if (err.response.status == 410) {
                        this.emailErr = err.response.data.message.Email[0];
                    }
                })
        }
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userDetails'));
        this.loginUser = user;

        if (user.Status == 'DC' || user.Status == 'CA') {
            this.$router.push({ name: 'user_dashboard' });
        }

        if (this.$route.params.user) {
            if (this.$route.params.user.allowedPages) {
                this.allowedPages = this.$route.params.user.allowedPages.split(',');
            }
            this.userData = this.$route.params.user;
            this.oldImagePrev = this.$route.params.user.image;
            // this.userData.Password = '';
        } else {
            this.$router.push({ name: 'view_dashboard_user' });
        }
        this.getStates()
    },
}

</script>